import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestCrossDismissDelete = {
    path: "/cross/:slug/:action/dismiss",
    method: RouteHttpVerb.DELETE
};
export { locationRestCrossDismissDelete };
